// Theme

const theme = {
  font: {
    primary: `'Lexend Regular'`,
    secondary: `'Lexend Medium'`,
    light: `'Lexend Light'`,
    normal: `'Lexend Regular'`,
    medium: `'Lexend Medium'`,
    semibold: `'Lexend Semibold'`,
    bold: `'Lexend Bold'`,
    extrabold: `'Lexend Extrabold'`,
  },
  font_size: {
    smallest: "font-size: 10px;line-height: 120%; ",
    xxxsmall: "font-size: 12px;line-height: 120%;",
    xxsmall: "font-size: 14px;line-height: 120%;",
    xsmall: "font-size: 16px;line-height: 120%;",
    small: "font-size: 17px;line-height: 120%;",
    normal: "font-size: 19px;line-height: 120%;",
    regular: "font-size: 20px; line-height: 120%;",
    medium: "font-size: 23px; line-height: 120%;",
    large: "font-size: 29px; line-height: 120%;",
    xlarge: "font-size: 37px; line-height: 120%;",
    xxlarge: "font-size: 46px; line-height: 120%;",
    xxxlarge: "font-size: 57px; line-height: 120%;",
  },

  color: {
    primary: "#1D293F",
    secondary: "#2266E2",
    secondary1: "#E5F1FF",
    accent: "#cca86e",
    background: {
      white: "#ffffff",
      light: "#F7F8FA",
    },
    white: {
      regular: "#ffffff",
      lessdark: "#faf9f8",
      dark: "#f6f6f6",
      darker: "#eeeeee",
    },
    black: {
      regular: "#1C1C1F",
      gray1: "#69696B",
      gray2:"#A7A7A7",
      gray3:"#D9D9D9",
      gray4:"#EDEDED",
      gray5:"#F5F5F5",
    },
    lightGreen: "#D3FF57",
    red: "#FF5758",
    blue: "#57E1FF",
    orange: "#F2994A",
    green: "#07A384",
    violet: "#676CF5",
    purple: "#CB52E8",
  },
  screen: {
    xs: "575px",
    sm: "767px",
    md: "991px",
    lg: "1199px",
  },
}

export default theme